import React from 'react';
import DialogTitle, {DialogTitleProps} from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {makeStyles} from '@material-ui/core/styles';

interface DialogCancelableTitleProps extends Omit<DialogTitleProps, 'disableTypography'> {
  onClose: () => void;
}

export const ClosableDialogTitle: React.FC<DialogCancelableTitleProps> = ({
  children,
  onClose,
  ...props
}) => {
  const {icon, wrap} = useStyles();
  return (
    <DialogTitle disableTypography className={wrap} {...props}>
      <h2>{children}</h2>
      <IconButton size="small" onClick={onClose} className={icon}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
};

const useStyles = makeStyles(() => ({
  icon: {
    flex: '0 1',
  },
  wrap: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: 52,
    padding: '11px 12px 11px 24px',
  },
}));
